// import React from "react";
// import { Box, Button, Typography, Paper, Avatar } from "@mui/material";
// import {
//   Timeline,
//   TimelineItem,
//   TimelineSeparator,
//   TimelineDot,
//   TimelineConnector,
//   TimelineContent,
// } from "@mui/lab";

// const ViewMoreLeads = () => {
//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       console.log("Uploaded file:", file.name);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         padding: "16px",
//         gap: "16px",
//         backgroundColor: "#f5f8fa",
//         fontFamily: "'Roboto', sans-serif",
//         color: "#333",
//       }}
//     >
//       {/* Top Section */}
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "row",
//           gap: "16px",
//           flex: "1",
//         }}
//       >
//         {/* Left Column: User Details and Follow-Up Employees */}
//         <Box
//           sx={{
//             flex: "1 1 24%",
//             display: "flex",
//             flexDirection: "column",
//             gap: "16px",
//           }}
//         >
//           {/* User Details */}
//           <Paper
//             elevation={3}
//             sx={{
//               padding: "16px",
//               display: "flex",
//               flexDirection: "column",
//               gap: "8px",
//               backgroundColor: "#ffffff",
//               height: "45%",
//               color: "#222",
//             }}
//           >
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: "bold", color: "#1e88e5", textAlign: "center" }}
//             >
//               User Details
//             </Typography>
//             <Box sx={{ lineHeight: 1.8, fontWeight: 500, marginLeft: "8px" }}>
//               <Typography variant="body1" sx={{ marginBottom: "4px" }}>
//                 <b>Name:</b> Ragu
//               </Typography>
//               <Typography variant="body1" sx={{ marginBottom: "4px" }}>
//                 <b>Mobile Number:</b> +91 9876543210
//               </Typography>
//               <Typography variant="body1" sx={{ marginBottom: "4px" }}>
//                 <b>Email:</b> ragu@example.com
//               </Typography>
//               <Typography variant="body1" sx={{ marginBottom: "4px" }}>
//                 <b>Address:</b> 123 Example Street, Bangalore
//               </Typography>
//               <Typography variant="body1" sx={{ marginBottom: "4px" }}>
//                 <b>Occupation:</b> Software Developer
//               </Typography>
//             </Box>
//           </Paper>

//           {/* Follow-Up Employees */}
//           <Paper
//             elevation={3}
//             sx={{
//               padding: "12px",
//               display: "flex",
//               flexDirection: "column",
//               gap: "8px",
//               alignItems: "center",
//               backgroundColor: "#e3f2fd",
//               height: "20%",
//               justifyContent: "center",
//             }}
//           >
//             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e88e5" }}>
//               Follow-Up Employees
//             </Typography>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: "8px",
//                 justifyContent: "center",
//               }}
//             >
//               {"E1 E2 E3 E4".split(" ").map((emp, index) => (
//                 <Avatar
//                   key={index}
//                   sx={{
//                     backgroundColor: "#ff7043",
//                     color: "#fff",
//                     cursor: "pointer",
//                     transition: "transform 0.3s, background-color 0.3s",
//                     "&:hover": {
//                       transform: "scale(1.2)",
//                       backgroundColor: "#d84315",
//                     },
//                   }}
//                 >
//                   {emp}
//                 </Avatar>
//               ))}
//             </Box>
//           </Paper>
//         </Box>

//         {/* Buttons Section */}
//         <Paper
//           elevation={3}
//           sx={{
//             flex: "1 1 30%",
//             padding: "16px",
//             display: "grid",
//             gridTemplateColumns: "repeat(2, 1fr)",
//             gap: "8px",
//             backgroundColor: "#ffffff",
//             height: "72%",
//           }}
//         >
//           {[...Array(8)].map((_, index) => (
//             <Button
//               key={index}
//               variant="outlined"
//               color="secondary"
//               component={index < 6 ? "label" : "button"}
//               sx={{
//                 padding: "8px",
//                 textTransform: "capitalize",
//                 borderColor: "#0288d1",
//                 color: "#0288d1",
//                 "&:hover": {
//                   backgroundColor: "#b3e5fc",
//                 },
//               }}
//             >
//               {index < 6 ? (
//                 <>
//                   Button {index + 1}
//                   <input type="file" hidden onChange={handleFileUpload} />
//                 </>
//               ) : (
//                 `Button ${index + 1}`
//               )}
//             </Button>
//           ))}
//         </Paper>

//         {/* History Section */}
//         <Paper
//           elevation={3}
//           sx={{
//             flex: "1 1 24%",
//             padding: "16px",
//             backgroundColor: "#f7f7f7",
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{ fontWeight: "bold", color: "#1e88e5", marginBottom: "16px", textAlign: "center" }}
//           >
//             History
//           </Typography>
//           <Timeline
//             sx={{
//               position: "relative",
//               marginLeft: "0px",
//               "& .MuiTimelineItem-root": {
//                 minHeight: "80px",
//               },
//             }}
//           >
//             {[
//               { title: "Order Placed", description: "Order #12345 has been placed successfully." },
//               { title: "Payment Confirmed", description: "Your payment has been processed." },
//               { title: "Shipped", description: "Your package is on the way." },
//               { title: "Out for Delivery", description: "Package will arrive soon." },
//               { title: "Delivered", description: "Order delivered to your doorstep." },
//             ].map((event, index) => (
//               <TimelineItem key={index}>
//                 <TimelineSeparator>
//                   <TimelineDot
//                     color={index === 4 ? "success" : "primary"}
//                     sx={{ boxShadow: "0 0 4px rgba(0,0,0,0.3)" }}
//                   />
//                   {index < 4 && <TimelineConnector />}
//                 </TimelineSeparator>
//                 <TimelineContent>
//                   <Typography variant="body1" sx={{ fontWeight: "bold" }}>
//                     {event.title}
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: "#555" }}>
//                     {event.description}
//                   </Typography>
//                 </TimelineContent>
//               </TimelineItem>
//             ))}
//           </Timeline>
//           <Typography
//             variant="body2"
//             sx={{
//               marginTop: "16px",
//               lineHeight: 1.6,
//               color: "#555",
//             }}
//           >
//             The timeline above shows the key steps of your order. For further details, please contact support.
//           </Typography>
//         </Paper>
//       </Box>

//       {/* New Section */}
//       <Paper
//         elevation={3}
//         sx={{
//           width: "calc(24% + 30% + 16px)", // Match the combined width of Follow-Up Employees and Buttons sections
//           padding: "16px",
//           marginLeft: "0",
//           backgroundColor: "#e1f5fe",
//           display: "flex",
//           flexDirection: "column",
//           gap: "8px",
//           alignSelf: "flex-start",
//         }}
//       >
//         <Typography variant="h6" sx={{ fontWeight: "bold", color: "#01579b" }}>
//           New Section
//         </Typography>
        
//       </Paper>
//     </Box>
//   );
// };

// export default ViewMoreLeads;


import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { leadsApis } from "../../Data/axios";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Import or create these components based on your needs
import Profile from "./ViewMore/Profile";
import Histories from "./ViewMore/Histories";
import Notes from "./ViewMore/Notes";

// Styled components from MainViewMore
const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
    backgroundColor: "#635ee7",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: "#C0B476",
    "&.Mui-selected": {
      color: "#000000",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "red",
    },
  })
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Main component
const ViewMoreLeads = () => {
  const [value, setValue] = useState(0);
  const [leadData, setLeadData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Get any state passed to this component
  const { state } = location || {};
  const safeState = state || { object: "test" };

  useEffect(() => {
    const fetchLeadData = async () => {
      setLoading(true);
      try {
        // Use leadsApis.getbyId instead of viewMoreById
        const response = await leadsApis.getbyId(id);
        if (response) {
          console.log("Lead data:", response);
          setLeadData(response);
        }
      } catch (error) {
        console.error("Error fetching lead data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchLeadData();
    }
  }, [id]);

  // Handle tab changes and URL updates
  const handleChange = (event, newValue) => {
    if (newValue === 1) {
      navigate(`/leads/${id}?tab=history`, { state });
    }
    if (newValue === 2) {
      navigate(`/leads/${id}?tab=notes`, { state });
    }
    if (newValue === 0) {
      navigate(`/leads/${id}`, { state });
    }
    setValue(newValue);
  };

  return (
    <Card sx={{ backgroundColor: "white" }}>
      <CardContent>
        <Box sx={{ maxWidth: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", background: "white" }}>
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="lead tabs"
            >
              <StyledTab label="Profile" {...a11yProps(0)} />
              <StyledTab label="History" {...a11yProps(1)} />
              <StyledTab label="Notes" {...a11yProps(2)} />
            </StyledTabs>
          </Box>
          <hr />
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", padding: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <CustomTabPanel value={value} index={0}>
                <Profile state={{ ...safeState, data: leadData }} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Histories leadId={id} data={leadData} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <Notes leadId={id} data={leadData} />
              </CustomTabPanel>
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ViewMoreLeads;